(function () {
  const sidebarSelector = '#site-cart-sidebar';
  const subtotalSelector = sidebarSelector + ' #AjaxCartSubtotal';
  const deliverySlotSelector = '[data-ys-zapiet-delivery-slot]';
  const appSelector = sidebarSelector + ' #storePickupApp';
  const readyAttribute = 'ysZapietDeliveryModalReady';
  const storageKey = 'ysZapietDeliverySelection';
  const summaryStorageKey = 'ysZapietDeliverySummary';
  const languageText = {
    de: {
      fallbackSummary: 'Liefertermin / Abstellort ausw\u00e4hlen (optional)',
      triggerLabel: 'Liefertermin:',
      editable: '\u00e4nderbar',
      modalTitle: 'Lieferung zu deinem Wunschtermin:',
      confirm: 'Eingabe best\u00e4tigen',
      closeLabel: 'Liefertermin-Auswahl schlie\u00dfen',
      weekdays: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
      months: ['Januar', 'Februar', 'M\u00e4rz', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
    },
    fr: {
      fallbackSummary: 'Date de livraison / lieu de d\u00e9p\u00f4t (optionnel)',
      triggerLabel: 'Date de livraison :',
      editable: 'modifiable',
      modalTitle: 'Livraison \u00e0 la date souhait\u00e9e :',
      confirm: 'Confirmer',
      closeLabel: 'Fermer la s\u00e9lection de la date de livraison',
      weekdays: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
      months: ['janvier', 'f\u00e9vrier', 'mars', 'avril', 'mai', 'juin', 'juillet', 'ao\u00fbt', 'septembre', 'octobre', 'novembre', 'd\u00e9cembre']
    }
  };
  const dateButtonSelector = '.Zapiet-Calendar__Dates button, button.picker__day';
  const monthLookup = {
    jan: 0,
    januar: 0,
    january: 0,
    janvier: 0,
    feb: 1,
    februar: 1,
    february: 1,
    fevrier: 1,
    mar: 2,
    march: 2,
    maerz: 2,
    marz: 2,
    mars: 2,
    apr: 3,
    april: 3,
    avril: 3,
    mai: 4,
    may: 4,
    jun: 5,
    juni: 5,
    june: 5,
    juin: 5,
    jul: 6,
    juli: 6,
    july: 6,
    juillet: 6,
    aug: 7,
    august: 7,
    aout: 7,
    sep: 8,
    sept: 8,
    september: 8,
    septembre: 8,
    okt: 9,
    oktober: 9,
    oct: 9,
    october: 9,
    octobre: 9,
    nov: 10,
    november: 10,
    novembre: 10,
    dez: 11,
    dezember: 11,
    dec: 11,
    december: 11,
    decembre: 11
  };
  let observer = null;
  let activeApp = null;
  let activeShell = null;
  let viewportListenersReady = false;
  let languageListenersReady = false;
  let observerPending = false;
  const defaultDateRetryLimit = 40;

  function getDefaultDateRetryDelay(attempt) {
    if (attempt < 12) return 250;
    if (attempt < 24) return 500;
    return 1000;
  }

  function createElement(tagName, className, text) {
    const element = document.createElement(tagName);
    if (className) element.className = className;
    if (text) element.textContent = text;
    return element;
  }

  function normalizeLanguage(value) {
    return String(value || '').trim().toLowerCase().replace('_', '-').split('-')[0];
  }

  function getCurrentLanguage() {
    if (window.ysCartLocaleGuard && typeof window.ysCartLocaleGuard.currentLanguage === 'function') {
      const guardedLanguage = normalizeLanguage(window.ysCartLocaleGuard.currentLanguage());
      if (languageText[guardedLanguage]) return guardedLanguage;
    }

    const pathLanguage = normalizeLanguage((window.location.pathname.match(/^\/([a-z]{2})(?:\/|$)/i) || [])[1]);
    if (languageText[pathLanguage]) return pathLanguage;

    const htmlLanguage = normalizeLanguage(document.documentElement.lang);
    return languageText[htmlLanguage] ? htmlLanguage : 'de';
  }

  function getText() {
    return languageText[getCurrentLanguage()] || languageText.de;
  }

  function getFallbackSummary() {
    return getText().fallbackSummary;
  }

  function isFallbackSummary(summary) {
    const normalizedSummary = String(summary || '').trim();
    return Object.keys(languageText).some(function (language) {
      return normalizedSummary === languageText[language].fallbackSummary;
    });
  }

  function readStoredSelection() {
    try {
      const value = window.sessionStorage.getItem(storageKey);
      return value ? JSON.parse(value) : [];
    } catch (error) {
      return [];
    }
  }

  function writeStoredSelection(selection) {
    try {
      if (selection.length) {
        window.sessionStorage.setItem(storageKey, JSON.stringify(selection));
      }
    } catch (error) {
    }
  }

  function readStoredSummary() {
    try {
      return normalizeSummary(window.sessionStorage.getItem(summaryStorageKey) || '');
    } catch (error) {
      return '';
    }
  }

  function writeStoredSummary(summary) {
    try {
      const normalizedSummary = normalizeSummary(summary);
      if (normalizedSummary && !isFallbackSummary(normalizedSummary)) {
        window.sessionStorage.setItem(summaryStorageKey, normalizedSummary);
      }
    } catch (error) {
    }
  }

  function getPersistableFields(app) {
    return Array.from(app.querySelectorAll('input, select, textarea')).filter(function (field) {
      const type = (field.getAttribute('type') || '').toLowerCase();
      return !field.disabled && type !== 'radio' && type !== 'checkbox';
    });
  }

  function getReadableFields(app) {
    return getPersistableFields(app).filter(function (field) {
      const type = (field.getAttribute('type') || '').toLowerCase();
      return type !== 'hidden';
    });
  }

  function getFieldValue(field) {
    if (!field) return '';
    const value = field.value || field.textContent || '';
    return value.trim();
  }

  function getFieldSignature(field, index) {
    return [
      field.tagName || '',
      field.getAttribute('type') || '',
      field.getAttribute('name') || '',
      field.id || '',
      field.getAttribute('placeholder') || '',
      String(index)
    ].join('|');
  }

  function captureSelection(app) {
    return getPersistableFields(app).map(function (field, index) {
      return {
        id: field.id || '',
        index: index,
        name: field.getAttribute('name') || '',
        placeholder: field.getAttribute('placeholder') || '',
        signature: getFieldSignature(field, index),
        tagName: field.tagName || '',
        type: field.getAttribute('type') || '',
        value: getFieldValue(field)
      };
    }).filter(function (entry) {
      return entry.value.length > 0;
    });
  }

  function setNativeValue(field, value) {
    const descriptor = Object.getOwnPropertyDescriptor(field.constructor.prototype, 'value');
    if (descriptor && descriptor.set) {
      descriptor.set.call(field, value);
    } else {
      field.value = value;
    }
  }

  function restoreSelection(app) {
    const storedSelection = readStoredSelection();
    if (!storedSelection.length) return false;

    const fields = getPersistableFields(app);
    let restored = false;

    storedSelection.forEach(function (entry) {
      const field = fields.find(function (candidate, index) {
        return getFieldSignature(candidate, index) === entry.signature;
      }) || fields.find(function (candidate) {
        return entry.name && candidate.getAttribute('name') === entry.name;
      }) || fields.find(function (candidate) {
        return entry.id && candidate.id === entry.id;
      }) || fields.find(function (candidate, index) {
        return Number(entry.index) === index &&
          (candidate.tagName || '') === (entry.tagName || '') &&
          (candidate.getAttribute('type') || '') === (entry.type || '');
      });

      if (!field) return;

      setNativeValue(field, entry.value);
      field.dispatchEvent(new Event('input', { bubbles: true }));
      field.dispatchEvent(new Event('change', { bubbles: true }));
      restored = true;
    });

    return restored;
  }

  function saveSelection(app) {
    normalizeVisibleDateFields(app);

    const selection = captureSelection(app);
    if (selection.length) {
      writeStoredSelection(selection);
    }

    const summary = getZapietSummary(app);
    if (!isFallbackSummary(summary)) {
      writeStoredSummary(summary);
    }
  }

  function getReadableValue(field) {
    return normalizeReadableValue(getFieldValue(field));
  }

  function normalizeMonthToken(token) {
    return String(token || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\./g, '');
  }

  function createLocalDate(year, monthIndex, day) {
    const date = new Date(year, monthIndex, day);
    if (
      date.getFullYear() !== year ||
      date.getMonth() !== monthIndex ||
      date.getDate() !== day
    ) {
      return null;
    }
    return date;
  }

  function parseSummaryDate(value) {
    if (!value) return null;

    const text = String(value).trim();
    let match = text.match(/\b(\d{4})-(\d{1,2})-(\d{1,2})\b/);
    if (match) {
      return createLocalDate(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    }

    match = text.match(/\b(\d{1,2})[.\-/](\d{1,2})[.\-/](\d{4})\b/);
    if (match) {
      return createLocalDate(Number(match[3]), Number(match[2]) - 1, Number(match[1]));
    }

    match = text.match(/\b(\d{1,2})\.?\s+([A-Za-z\u00c0-\u017f]+),?\s+(\d{4})\b/);
    if (match) {
      const monthIndex = monthLookup[normalizeMonthToken(match[2])];
      if (typeof monthIndex === 'number') {
        return createLocalDate(Number(match[3]), monthIndex, Number(match[1]));
      }
    }

    match = text.match(/\b([A-Za-z\u00c0-\u017f]+)\s+(\d{1,2}),?\s+(\d{4})\b/);
    if (match) {
      const monthIndex = monthLookup[normalizeMonthToken(match[1])];
      if (typeof monthIndex === 'number') {
        return createLocalDate(Number(match[3]), monthIndex, Number(match[2]));
      }
    }

    return null;
  }

  function formatSummaryDate(date) {
    const text = getText();

    if (getCurrentLanguage() === 'fr') {
      return text.weekdays[date.getDay()] + ', ' + date.getDate() + ' ' + text.months[date.getMonth()] + ' ' + date.getFullYear();
    }

    return text.weekdays[date.getDay()] + ', ' + date.getDate() + '. ' + text.months[date.getMonth()] + ' ' + date.getFullYear();
  }

  function normalizeReadableValue(value) {
    const date = parseSummaryDate(value);
    return date ? formatSummaryDate(date) : value;
  }

  function normalizeSummary(summary) {
    if (!summary || isFallbackSummary(summary)) return '';
    return String(summary)
      .split(' / ')
      .map(normalizeReadableValue)
      .join(' / ');
  }

  function normalizeVisibleDateFields(app) {
    getReadableFields(app).forEach(function (field) {
      if (!field.matches || !field.matches('input[type="text"], input:not([type]), textarea')) return;

      const value = getFieldValue(field);
      const normalizedValue = normalizeReadableValue(value);
      if (normalizedValue && normalizedValue !== value) {
        setNativeValue(field, normalizedValue);
      }
    });
  }

  function getZapietSummary(app) {
    const readableValues = getReadableFields(app).map(getReadableValue).filter(Boolean);

    if (!readableValues.length) {
      return readStoredSummary() || getFallbackSummary();
    }

    return readableValues.slice(0, 2).join(' / ');
  }

  function clampNumber(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function clearModalPosition(modal) {
    modal.classList.remove('ys-zapiet-delivery-modal--fixed');
    modal.style.removeProperty('--ys-zapiet-modal-left');
    modal.style.removeProperty('--ys-zapiet-modal-top');
    modal.style.removeProperty('--ys-zapiet-modal-width');
    modal.style.removeProperty('--ys-zapiet-modal-max-height');
  }

  function getVisibleBounds(sidebar) {
    const viewport = window.visualViewport;
    const sidebarRect = sidebar ? sidebar.getBoundingClientRect() : null;
    const viewportTop = viewport ? viewport.offsetTop : 0;
    const viewportLeft = viewport ? viewport.offsetLeft : 0;
    const viewportRight = viewport ? viewport.offsetLeft + viewport.width : window.innerWidth;
    const viewportBottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;

    return {
      top: Math.max(viewportTop + 8, sidebarRect ? sidebarRect.top + 8 : viewportTop + 8),
      right: Math.min(viewportRight - 8, sidebarRect ? sidebarRect.right - 8 : viewportRight - 8),
      bottom: Math.min(viewportBottom - 10, sidebarRect ? sidebarRect.bottom - 8 : viewportBottom - 10),
      left: Math.max(viewportLeft + 8, sidebarRect ? sidebarRect.left + 8 : viewportLeft + 8)
    };
  }

  function positionModalWithinViewport(shell) {
    const modal = shell && shell.querySelector('.ys-zapiet-delivery-modal');
    const dialog = modal && modal.querySelector('.ys-zapiet-delivery-modal__dialog');
    const sidebar = document.getElementById('site-cart-sidebar');
    if (!modal || !dialog || !modal.classList.contains('ys-zapiet-delivery-modal--open')) return;

    clearModalPosition(modal);

    const bounds = getVisibleBounds(sidebar);
    const rect = modal.getBoundingClientRect();
    const height = Math.max(rect.height, dialog.scrollHeight, dialog.offsetHeight);
    const availableHeight = Math.max(260, bounds.bottom - bounds.top);

    if (rect.top >= bounds.top && rect.bottom <= bounds.bottom) return;

    const maxWidth = Math.max(260, bounds.right - bounds.left);
    const width = Math.min(Math.max(rect.width, 260), maxWidth);
    const left = clampNumber(rect.left || bounds.left, bounds.left, bounds.right - width);
    const top = height >= availableHeight
      ? bounds.top
      : clampNumber(rect.top, bounds.top, bounds.bottom - height);

    modal.style.setProperty('--ys-zapiet-modal-left', left + 'px');
    modal.style.setProperty('--ys-zapiet-modal-top', top + 'px');
    modal.style.setProperty('--ys-zapiet-modal-width', width + 'px');
    modal.style.setProperty('--ys-zapiet-modal-max-height', availableHeight + 'px');
    modal.classList.add('ys-zapiet-delivery-modal--fixed');
  }

  function scheduleModalPosition(shell) {
    window.requestAnimationFrame(function () {
      positionModalWithinViewport(shell);
    });
  }

  function scheduleActiveModalPosition() {
    if (activeShell) scheduleModalPosition(activeShell);
    if (activeShell && activeApp) scheduleCalendarContainment(activeShell, activeApp);
  }

  function clearCalendarContainment(shell) {
    const modal = shell && shell.querySelector('.ys-zapiet-delivery-modal');
    if (modal) modal.classList.remove('ys-zapiet-delivery-modal--calendar-contained');
  }

  function getCalendarElement(app) {
    return app.querySelector('.Zapiet-Calendar__Wrapper, .picker__box, .picker__frame, .picker');
  }

  function calendarNeedsContainment(app) {
    const calendar = getCalendarElement(app);
    const sidebar = document.getElementById('site-cart-sidebar');
    if (!calendar) return false;

    const rect = calendar.getBoundingClientRect();
    if (!rect.width || !rect.height) return false;

    const bounds = getVisibleBounds(sidebar);
    return rect.top < bounds.top ||
      rect.left < bounds.left ||
      rect.right > bounds.right ||
      rect.bottom > bounds.bottom;
  }

  function updateCalendarContainment(shell, app) {
    const modal = shell && shell.querySelector('.ys-zapiet-delivery-modal');
    if (!modal || !modal.classList.contains('ys-zapiet-delivery-modal--open')) return;

    if (modal.classList.contains('ys-zapiet-delivery-modal--calendar-contained')) {
      scheduleModalPosition(shell);
      return;
    }

    window.requestAnimationFrame(function () {
      if (calendarNeedsContainment(app)) {
        modal.classList.add('ys-zapiet-delivery-modal--calendar-contained');
        scheduleModalPosition(shell);
      }
    });
  }

  function scheduleCalendarContainment(shell, app) {
    window.requestAnimationFrame(function () {
      updateCalendarContainment(shell, app);
    });
  }

  function setOpen(shell, isOpen) {
    const dialog = shell.querySelector('.ys-zapiet-delivery-modal');
    const trigger = shell.querySelector('.ys-zapiet-delivery-trigger');
    if (!dialog || !trigger) return;

    dialog.classList.toggle('ys-zapiet-delivery-modal--open', isOpen);
    dialog.setAttribute('aria-hidden', String(!isOpen));
    trigger.setAttribute('aria-expanded', String(isOpen));

    if (isOpen) {
      scheduleModalPosition(shell);
    } else {
      clearModalPosition(dialog);
      clearCalendarContainment(shell);
    }
  }

  function updateTriggerLabel(shell, app) {
    const label = shell.querySelector('.ys-zapiet-delivery-trigger__label');
    const value = shell.querySelector('.ys-zapiet-delivery-trigger__value');
    if (!label) return;

    const summary = getZapietSummary(app);
    if (value) {
      value.textContent = summary;
      label.textContent = getText().triggerLabel;
    } else {
      label.textContent = summary;
    }
  }

  function updateStaticShellText(shell) {
    if (!shell) return;

    const text = getText();
    const meta = shell.querySelector('.ys-zapiet-delivery-trigger__meta');
    const title = shell.querySelector('.ys-zapiet-delivery-modal__title');
    const confirmButton = shell.querySelector('.ys-zapiet-delivery-modal__confirm');
    const closeButton = shell.querySelector('.ys-zapiet-delivery-modal__close');

    if (meta) meta.textContent = text.editable;
    if (title) title.textContent = text.modalTitle;
    if (confirmButton) confirmButton.textContent = text.confirm;
    if (closeButton) closeButton.setAttribute('aria-label', text.closeLabel);
  }

  function refreshShellLanguage() {
    if (!activeShell) return;

    updateStaticShellText(activeShell);
    if (activeApp) {
      updateTriggerLabel(activeShell, activeApp);
    }
  }

  function getCalendarScope(app) {
    const sidebar = document.getElementById('site-cart-sidebar');

    if (sidebar && (
      sidebar.querySelector(dateButtonSelector) ||
      sidebar.querySelector('.picker__weekday, .Zapiet-Calendar__Weekday, .picker__table')
    )) {
      return sidebar;
    }

    if (document.querySelector(dateButtonSelector) || document.querySelector('.picker__weekday, .Zapiet-Calendar__Weekday, .picker__table')) {
      return document;
    }

    return app;
  }

  function getDateButtons(app) {
    return Array.from(getCalendarScope(app).querySelectorAll(dateButtonSelector));
  }

  function isUnavailableDate(button) {
    return (
      button.disabled ||
      button.getAttribute('aria-disabled') === 'true' ||
      button.classList.contains('Zapiet-Calendar__Date--disabled') ||
      button.classList.contains('picker__day--disabled')
    );
  }

  function isSelectedDate(button) {
    return (
      button.getAttribute('aria-selected') === 'true' ||
      button.classList.contains('Zapiet-Calendar__Date--selected') ||
      button.classList.contains('picker__day--selected')
    );
  }

  function getDateTimestamp(button) {
    const pickValue = button.getAttribute('data-pick') || button.dataset.pick;
    if (!pickValue) return null;
    const timestamp = Number(pickValue);
    return Number.isFinite(timestamp) ? timestamp : null;
  }

  function isPastDate(button) {
    const timestamp = getDateTimestamp(button);
    if (!timestamp) return false;

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return timestamp < today.getTime();
  }

  function hasChosenDate(app) {
    if (getReadableFields(app).some(function (field) {
      return getFieldValue(field).length > 0;
    })) {
      return true;
    }

    return getDateButtons(app).some(isSelectedDate);
  }

  function withStoppedAppClick(app, callback) {
    const stopAtApp = function (event) {
      event.stopPropagation();
    };

    app.addEventListener('click', stopAtApp);
    callback();

    window.setTimeout(function () {
      app.removeEventListener('click', stopAtApp);
    }, 0);
  }

  function openCalendar(app) {
    const trigger = app.querySelector('.Zapiet-InputWithPrefix__Wrapper input, input[readonly], .Zapiet-InputWithPrefix__Wrapper, input');
    if (!trigger) return false;

    withStoppedAppClick(app, function () {
      trigger.click();
    });

    return true;
  }

  function clickDateButton(app, button) {
    ['mousedown', 'mouseup', 'click'].forEach(function (eventName) {
      button.dispatchEvent(new MouseEvent(eventName, { bubbles: true, cancelable: true, view: window }));
    });
  }

  function dispatchZapietFieldEvent(field) {
    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function dispatchZapietFieldEvents(app) {
    getPersistableFields(app).forEach(function (field) {
      if (!getFieldValue(field)) return;

      dispatchZapietFieldEvent(field);
    });
  }

  function commitZapietSelection(app, shell) {
    dispatchZapietFieldEvents(app);
    saveSelection(app);
    updateTriggerLabel(shell, app);
  }

  function formatIsoDate(date) {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return date.getFullYear() + '-' + month + '-' + day;
  }

  function parseDateButtonDate(button) {
    if (!button) return null;

    const label = button.getAttribute('aria-label') || button.textContent || '';
    const withoutWeekday = String(label).replace(/^[^,]+,\s*/, '');
    return parseSummaryDate(withoutWeekday) || parseSummaryDate(label);
  }

  function applyDefaultDateFields(app, button) {
    const date = parseDateButtonDate(button);
    if (!date) return false;

    const dateField = app.querySelector('#Zapiet-InputCalendar__shipping, input[name="datetime"]');
    const isoField = app.querySelector('#Zapiet-InputCalendar__shippingDate_ISO');
    const displayValue = formatSummaryDate(date);
    const isoValue = formatIsoDate(date);
    let applied = false;

    if (dateField) {
      setNativeValue(dateField, displayValue);
      dispatchZapietFieldEvent(dateField);
      applied = true;
    }

    if (isoField) {
      setNativeValue(isoField, isoValue);
      dispatchZapietFieldEvent(isoField);
    }

    button.classList.add('Zapiet-Calendar__Date--selected', 'picker__day--selected');
    button.setAttribute('aria-selected', 'true');

    return applied;
  }

  function getLegacyFinalValues() {
    const scripts = Array.from(document.scripts);

    for (const script of scripts) {
      const text = script.textContent || '';
      if (!text.includes('#storePickupApp') || !text.includes('final_1_7')) continue;

      const finalOneSeven = text.match(/final_1_7\s*=\s*parseInt\("([^"]*)"/);
      const finalZeroFive = text.match(/final_0_5\s*=\s*parseInt\("([^"]*)"/);

      return {
        finalOneSeven: finalOneSeven ? parseInt(finalOneSeven[1], 10) : NaN,
        finalZeroFive: finalZeroFive ? parseInt(finalZeroFive[1], 10) : NaN
      };
    }

    return null;
  }

  function applyLegacyDateDisable(app) {
    const legacyValues = getLegacyFinalValues();
    if (!legacyValues) return;

    if (legacyValues.finalOneSeven !== 0 && legacyValues.finalZeroFive !== 0) return;

    const todayButton = app.querySelector('.Zapiet-Calendar__Dates button.picker__day--today');
    if (!todayButton) return;

    if (todayButton.classList.contains('Zapiet-Calendar__Date--disabled')) {
      const nextEnabled = Array.from(todayButton.parentElement.querySelectorAll('button')).slice(
        Array.from(todayButton.parentElement.querySelectorAll('button')).indexOf(todayButton) + 1
      ).find(function (button) {
        return !button.classList.contains('Zapiet-Calendar__Date--disabled');
      });

      if (nextEnabled) {
        nextEnabled.classList.add('Zapiet-Calendar__Date--disabled', 'picker__day--disabled');
        nextEnabled.setAttribute('aria-disabled', 'true');
      }
    } else {
      todayButton.classList.add('Zapiet-Calendar__Date--disabled', 'picker__day--disabled');
      todayButton.setAttribute('aria-disabled', 'true');
    }
  }

  function getRowSignature(elements) {
    return elements.map(function (element) {
      return element.textContent.trim() + ':' + (element.getAttribute('data-pick') || '');
    }).join('|');
  }

  function rotateSevenColumnRow(parent, elements, index) {
    if (elements.length !== 7) return;

    const key = 'ysMondayFirstSignature' + index;
    const signature = getRowSignature(elements);
    if (parent.dataset[key] === signature) return;

    parent.insertBefore(elements[0], elements[6].nextSibling);
    parent.dataset[key] = getRowSignature(elements.slice(1).concat(elements[0]));
  }

  function applyMondayFirstCalendar(app) {
    // Keep Zapiet's rendered calendar order intact. Reordering cells after render
    // can detach dates from their correct weekday columns when months change.
  }

  function selectDefaultDate(app, shell, attempt) {
    applyMondayFirstCalendar(app);
    applyLegacyDateDisable(app);

    if (hasChosenDate(app)) {
      saveSelection(app);
      updateTriggerLabel(shell, app);
      return;
    }

    const buttons = getDateButtons(app);
    if (!buttons.length) {
      openCalendar(app);
      if (attempt < defaultDateRetryLimit) {
        scheduleDefaultDate(app, shell, attempt + 1);
      }
      return;
    }

    const firstAvailable = buttons.find(function (button) {
      return !isUnavailableDate(button) && !isPastDate(button);
    });

    if (!firstAvailable) {
      if (attempt < defaultDateRetryLimit) scheduleDefaultDate(app, shell, attempt + 1);
      return;
    }

    clickDateButton(app, firstAvailable);
    applyDefaultDateFields(app, firstAvailable);
    commitZapietSelection(app, shell);

    window.setTimeout(function () {
      if (!hasChosenDate(app)) {
        applyDefaultDateFields(app, firstAvailable);
      }

      commitZapietSelection(app, shell);

      if (!hasChosenDate(app) && attempt < defaultDateRetryLimit) {
        scheduleDefaultDate(app, shell, attempt + 1);
      }
    }, 250);

    window.setTimeout(function () {
      if (!hasChosenDate(app)) {
        applyDefaultDateFields(app, firstAvailable);
      }

      commitZapietSelection(app, shell);
    }, 650);
  }

  function scheduleDefaultDate(app, shell, attempt) {
    if (!app || !shell) return;

    if (hasChosenDate(app)) {
      window.clearTimeout(Number(app.dataset.ysZapietDefaultTimer || 0));
      delete app.dataset.ysZapietDefaultTimer;
      return;
    }

    if (app.dataset.ysZapietDefaultTimer) return;

    const nextAttempt = Math.min(Number(attempt || 0), defaultDateRetryLimit);
    const timer = window.setTimeout(function () {
      delete app.dataset.ysZapietDefaultTimer;
      selectDefaultDate(app, shell, nextAttempt);
    }, getDefaultDateRetryDelay(nextAttempt));
    app.dataset.ysZapietDefaultTimer = String(timer);
  }

  function getDeliverySlot() {
    return document.querySelector(subtotalSelector + ' ' + deliverySlotSelector);
  }

  function ensureShellInDeliverySlot(shell) {
    const slot = getDeliverySlot();
    if (!slot || !shell || slot.contains(shell)) return false;

    slot.appendChild(shell);
    return true;
  }

  function refreshActiveCalendar() {
    if (!activeApp || !activeShell) return;

    applyMondayFirstCalendar(activeApp);
    scheduleDefaultDate(activeApp, activeShell, 0);
    scheduleModalPosition(activeShell);
    scheduleCalendarContainment(activeShell, activeApp);
  }

  function buildPrototype(app) {
    activeApp = app;
    app.classList.add('ys-zapiet-mounted');

    const textConfig = getText();
    const shell = createElement('div', 'ys-zapiet-delivery');
    const trigger = createElement('button', 'ys-zapiet-delivery-trigger');
    const text = createElement('span', 'ys-zapiet-delivery-trigger__text');
    const label = createElement('span', 'ys-zapiet-delivery-trigger__label', textConfig.triggerLabel);
    const value = createElement('span', 'ys-zapiet-delivery-trigger__value', readStoredSummary() || getFallbackSummary());
    const meta = createElement('span', 'ys-zapiet-delivery-trigger__meta', textConfig.editable);
    const modal = createElement('div', 'ys-zapiet-delivery-modal');
    const dialog = createElement('div', 'ys-zapiet-delivery-modal__dialog');
    const closeButton = createElement('button', 'ys-zapiet-delivery-modal__close');
    const title = createElement('p', 'ys-zapiet-delivery-modal__title', textConfig.modalTitle);
    const fields = createElement('div', 'ys-zapiet-delivery-modal__fields');
    const confirmButton = createElement('button', 'ys-zapiet-delivery-modal__confirm', textConfig.confirm);

    trigger.type = 'button';
    trigger.setAttribute('aria-expanded', 'false');
    text.append(label, value);
    trigger.append(text, meta);

    modal.setAttribute('aria-hidden', 'true');
    closeButton.type = 'button';
    closeButton.setAttribute('aria-label', textConfig.closeLabel);
    closeButton.innerHTML = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M17 1L1 17" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M1 1L17 17" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    confirmButton.type = 'button';

    dialog.append(closeButton, title, fields, confirmButton);
    modal.append(dialog);
    shell.append(trigger, modal);

    app.parentNode.insertBefore(shell, app);
    fields.appendChild(app);
    activeShell = shell;
    ensureShellInDeliverySlot(shell);

    const saveAndRefresh = function () {
      window.setTimeout(function () {
        saveSelection(app);
        updateTriggerLabel(shell, app);
        applyMondayFirstCalendar(app);
      }, 100);
    };

    trigger.addEventListener('click', function () {
      setOpen(shell, true);
      applyMondayFirstCalendar(app);

      window.setTimeout(function () {
        const firstField = app.querySelector('input:not([type="hidden"]), select, textarea, button');
        if (firstField) firstField.focus({ preventScroll: true });
        refreshActiveCalendar();
        scheduleCalendarContainment(shell, app);
      }, 50);

      window.setTimeout(refreshActiveCalendar, 200);
      window.setTimeout(refreshActiveCalendar, 500);
      window.setTimeout(refreshActiveCalendar, 900);
      window.setTimeout(scheduleActiveModalPosition, 1200);
      window.setTimeout(function () {
        scheduleCalendarContainment(shell, app);
      }, 1200);
    });

    closeButton.addEventListener('click', function () {
      saveAndRefresh();
      setOpen(shell, false);
      trigger.focus({ preventScroll: true });
    });

    confirmButton.addEventListener('click', function () {
      saveAndRefresh();
      setOpen(shell, false);
      trigger.focus({ preventScroll: true });
    });

    modal.addEventListener('click', function (event) {
      if (event.target === modal) {
        saveAndRefresh();
        setOpen(shell, false);
      }
    });

    app.addEventListener('input', saveAndRefresh, true);
    app.addEventListener('change', saveAndRefresh, true);
    app.addEventListener('click', saveAndRefresh, true);

    const restored = restoreSelection(app);
    updateTriggerLabel(shell, app);
    applyMondayFirstCalendar(app);

    if (!restored || !hasChosenDate(app)) {
      scheduleDefaultDate(app, shell, 0);
    }
  }

  function getCurrentShell() {
    if (activeShell && activeShell.querySelector('#storePickupApp')) {
      ensureShellInDeliverySlot(activeShell);
      return activeShell;
    }

    const app = document.querySelector(appSelector);
    const shell = app ? app.closest('.ys-zapiet-delivery') : null;
    if (shell) ensureShellInDeliverySlot(shell);
    return shell;
  }

  function bindActiveShell(shell) {
    if (!shell) return false;

    const app = shell.querySelector('#storePickupApp');
    if (!app) return false;

    activeShell = shell;
    activeApp = app;
    app.dataset[readyAttribute] = 'true';
    ensureShellInDeliverySlot(shell);
    updateStaticShellText(shell);
    updateTriggerLabel(shell, app);

    if (!hasChosenDate(app)) {
      scheduleDefaultDate(app, shell, 0);
    }

    return true;
  }

  function initZapietDeliveryModal() {
    const app = document.querySelector(appSelector);
    if (!app) return;

    if (app.dataset[readyAttribute] === 'true') {
      bindActiveShell(app.closest('.ys-zapiet-delivery'));
      return;
    }

    app.dataset[readyAttribute] = 'true';
    buildPrototype(app);
  }

  function scheduleObserverRefresh() {
    if (observerPending) return;

    observerPending = true;
    window.setTimeout(function () {
      observerPending = false;
      initZapietDeliveryModal();
      if (activeShell) ensureShellInDeliverySlot(activeShell);

      refreshActiveCalendar();
    }, 100);
  }

  function start() {
    initZapietDeliveryModal();

    if (!observer && document.body) {
      observer = new MutationObserver(scheduleObserverRefresh);
      observer.observe(document.getElementById('site-cart-sidebar') || document.body, { childList: true, subtree: true });
    }

    if (!viewportListenersReady) {
      viewportListenersReady = true;
      window.addEventListener('resize', scheduleActiveModalPosition, { passive: true });
      window.addEventListener('scroll', scheduleActiveModalPosition, { passive: true });

      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', scheduleActiveModalPosition, { passive: true });
        window.visualViewport.addEventListener('scroll', scheduleActiveModalPosition, { passive: true });
      }
    }

    if (!languageListenersReady) {
      languageListenersReady = true;
      document.addEventListener('ys:cart:locale-synced', refreshShellLanguage);

    }
  }

  function bindDeferredStart() {
    document.addEventListener('click', function (event) {
      const target = event.target;
      if (!target || typeof target.closest !== 'function') return;

      const cartTrigger = target.closest('[data-js-sidebar-handle][aria-controls="site-cart-sidebar"]');
      if (cartTrigger) start();
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindDeferredStart, { once: true });
  } else {
    bindDeferredStart();
  }

  window.ysZapietDeliveryModalEnsureSlot = function () {
    const shell = getCurrentShell();
    if (!shell) return false;

    return ensureShellInDeliverySlot(shell);
  };

  window.ysZapietDeliveryModalBeforeCartRefresh = function () {
    const shell = getCurrentShell();
    const app = activeApp || (shell ? shell.querySelector('#storePickupApp') : null);

    if (app) {
      saveSelection(app);
    }

    return shell;
  };

  window.ysZapietDeliveryModalAfterCartRefresh = function (preservedShell) {
    if (preservedShell && bindActiveShell(preservedShell)) {
      start();
      window.setTimeout(refreshActiveCalendar, 150);
      window.setTimeout(refreshActiveCalendar, 450);
      return;
    }

    activeApp = null;
    activeShell = null;
    window.setTimeout(start, 0);
    window.setTimeout(refreshActiveCalendar, 150);
    window.setTimeout(refreshActiveCalendar, 450);
  };
})();
